import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    const checkbox = event.target
    const url = checkbox.dataset.assetSettingsUrlParam
    const field = checkbox.dataset.assetSettingsFieldParam
    const value = checkbox.checked

    this.updateSetting(url, field, value, checkbox)
  }

  async updateSetting(url, field, value, checkbox) {
    const formData = new FormData()
    formData.append(field, value)

    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "Accept": "text/vnd.turbo-stream.html",
          "X-CSRF-Token": this.getCsrfToken()
        },
        body: formData
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const html = await response.text()
      Turbo.renderStreamMessage(html)
    } catch (error) {
      console.error("Failed to update setting:", error)
      checkbox.checked = !checkbox.checked
    }
  }

  getCsrfToken() {
    return document.querySelector('meta[name="csrf-token"]').content
  }
}
